import React from 'react'
import styled, { css, createGlobalStyle } from 'styled-components'
import LogoIcon from 'images/header/magic-logo.svg'
import mediaQuery from 'styles/mediaQuery'
import { Link } from 'gatsby'
import { Container } from 'components/magic/styled'
import colors from 'styles/colors'
import LogoIconDark from 'images/header/magic-logo-black.svg'
import MagicMobileHeader from 'components/magic/MagicHeader/MagicMobileHeader'
import NavButtons from './NavButtons'
import Navigation from './Navigation'

const HeaderStyled = styled.header`
  position: relative;
  left: 0;
  top: 0;
  z-index: 1000;
  width: 100%;
  box-sizing: border-box;
  padding: 28px 0;
  background-color: ${({ dark }) => (dark ? colors.black : colors.white)};
  color: ${({ dark }) => (dark ? colors.white : colors.black)};

  ${mediaQuery.bigTabletMin} {
    position: ${({ isFixed }) => (isFixed ? 'fixed' : 'relative')};
  }

  ${mediaQuery.tabletMax} {
    display: none;
  }
`

const ContainerStyled = styled(Container)`
  ${mediaQuery.bigTabletMin} {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
`

const LogoWrapper = styled(Link)`
  flex: 0 0 auto;
  padding-right: 30px;
`

const logoCss = css`
  width: 95px;
  height: 95px;

  ${mediaQuery.tabletMax} {
    width: 50px;
    height: 50px;
    margin-bottom: 15px;
  }
`

const LogoDarkTheme = styled(LogoIcon)`
  ${logoCss}
`

const Logo = styled(LogoIconDark)`
  ${logoCss}
`

const TopOffset = createGlobalStyle`
  body {
    ${mediaQuery.bigTabletMin} {
      padding-top: ${({ isFixed }) => (isFixed ? '160px' : '0px')};
    }
    ${mediaQuery.mobile} {
      padding-top: 100px;
    }
  }
`

const Header = ({ darkTheme, isFixed }) => (
  <>
    <TopOffset isFixed={isFixed} />
    <HeaderStyled dark={darkTheme} isFixed={isFixed}>
      <ContainerStyled>
        <LogoWrapper
          href="/info/magic-os"
          aria-label="Magic home"
          rel="noopener noreferrer nofollow"
        >
          {darkTheme ? <LogoDarkTheme /> : <Logo />}
        </LogoWrapper>
        <Navigation />
        <NavButtons />
      </ContainerStyled>
    </HeaderStyled>
    <MagicMobileHeader darkTheme={darkTheme} />
  </>
)

export default Header
